import { createGlobalStyle } from "styled-components";
import UniversLightWoff from "@fonts/univers-light.woff";
import UniversLightWoff2 from "@fonts/univers-light.woff2";
import UniversRomanWoff from "@fonts/univers-roman.woff";
import UniversRomanWoff2 from "@fonts/univers-roman.woff2";
import UniversBoldWoff from "@fonts/univers-bold.woff";
import UniversBoldWoff2 from "@fonts/univers-bold.woff2";
import UniversBoldCondWoff from "@fonts/univers-bold-cond.woff";
import UniversBoldCondWoff2 from "@fonts/univers-bold-cond.woff2";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "univers-light";
    src: local("univers-light"), url(${UniversLightWoff2}) format("woff2"),
      url(${UniversLightWoff}) format("woff");
  }

  @font-face {
    font-family: "univers-roman";
    src: local("univers-roman"), url(${UniversRomanWoff2}) format("woff2"),
      url(${UniversRomanWoff}) format("woff");
  }

  @font-face {
    font-family: "univers-bold";
    src: local("univers-bold"), url(${UniversBoldWoff2}) format("woff2"),
      url(${UniversBoldWoff}) format("woff");
  }

  @font-face {
    font-family: "univers-bold-cond";
    src: local("univers-bold-cond"), url(${UniversBoldCondWoff2}) format("woff2"),
      url(${UniversBoldCondWoff}) format("woff");
  }

  body {
        margin: 0;
        background-color: red;
      }

        #___gatsby {
        margin: 0;
        font-size: 18px;
        font-family: "univers-light", sans-serif;
        line-height: 1.4em;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;
        color: rgba(33, 23, 3, 1);
        box-sizing: border-box;
        margin: 0;
        overflow-x: clip;
      }

   a,
      a:visited {
        color: black;
        text-decoration: none;
      }

       button {
        padding: 0px;

        button:hover,
        button:focus {
          outline: none;
        }
      }
        
      img {
        max-width: 100%;
      }
`;

export default GlobalStyles;
